import { ExternalMemberValue } from "app/area/subscriber-groups/form/types-store";

export const createInitialExternalMember = (id: number) => ({
  memberNo: id,
  emailAddress: undefined,
  name: undefined
} as ExternalMemberValue);

export const createId = (value: ExternalMemberValue[]) => value.length > 0 ? Math.max(...value.map(item => item.memberNo)) + 1 : 1;
